export default __webpack_public_path__ + "static/media/case-ih-mxm-155.c2b5ff9e.jpg";